import React from 'react';
import { FieldTitle } from '../../molecules/Texts';

const AdminView = () => {
  return <FieldTitle>Panel Administracyjny</FieldTitle>;
};

export default AdminView;
